<script setup lang="ts">
import type Footer from '~/components/Footer.vue'
import { joinURL } from 'ufo'

const { signIn } = useAuth()

const isSigningIn = ref(false)

const handleEntraSignIn = async () => {
  if (isSigningIn.value) return
  isSigningIn.value = true
  try {
    await signIn(
      'azure-ad',
      {
        callbackUrl: joinURL(
          `${useRequestURL().protocol}//${useRequestURL().hostname}${useRequestURL().port === '80' || useRequestURL().port === '8080' ? '' : `:${useRequestURL().port}`}`,
          '/profile',
        ),
      },
      { prompt: 'login' },
    )
  } finally {
    isSigningIn.value = false
  }
}
</script>

<template>
  <div class="flex min-h-screen flex-col bg-blue-lighter">
    <header class="flex h-[71px] w-full items-center border-b border-b-blue-light bg-white lg:h-24">
      <div class="mx-auto flex w-full max-w-screen-2xl justify-between">
        <div class="ml-9 flex items-center justify-center lg:ml-4 2xl:ml-0">
          <NuxtLink to="/login">
            <SvgoBlixtappLogga class="aspect-[131/44] h-9 lg:h-11" filled />
          </NuxtLink>
        </div>
      </div>
    </header>
    <main class="grow">
      <slot></slot>
    </main>
    <Footer>
      <div class="mt-2 text-center">
        <button
          class="text-xs text-gray-300 hover:text-gray-400 disabled:opacity-50"
          :disabled="isSigningIn"
          @click="handleEntraSignIn"
        >
          Admin
        </button>
      </div>
    </Footer>
  </div>
</template>
